import { TextAreaProps } from '@widesk-ui/components/form/TextArea';
import Button            from '@widesk-ui/components/Button';
import { CopyOutlined }  from '@ant-design/icons';
import TextArea          from '@widesk-ui/components/form/TextArea';
import Space             from '@widesk-ui/components/Space';
import copyToClipboard   from '@widesk-ui/tools/copyToClipboard';

export default function TextAreaWithCopy(props: TextAreaProps & { copyMessage?: string }) {
	const { copyMessage, ...textAreaProps } = props;
	return (
		<Space.Compact style={{ width: '100%' }}>
			<TextArea
				{...textAreaProps}
			/>
			<Button
				disabled={!props.value}
				icon={<CopyOutlined />}
				onClick={() => copyToClipboard(props.value || '', copyMessage)}
				style={{ height: 'auto' }}
			/>
		</Space.Compact>
	);
}
